import { type DerivedEventLegacy } from '@verantos-dev/types-cohorts';
import { Derived_eventContext } from '@verantos-dev/util-cohort-builder-typescript-runtime';

import getInstanceEvents from '../helpers/getInstanceEvents';
import getMergedEvents from '../helpers/getMergedEvents';
import getSequenceEvents from '../helpers/getSequenceEvents';

export const generateDerivedEventFromDSL = (
  derivedEvents: Derived_eventContext[],
  dirty?: boolean // set to true to annotate input fields as dirty
): DerivedEventLegacy[] => {
  try {
    return derivedEvents?.map((event: Derived_eventContext) => {
      if (event.merged_event()) {
        return getMergedEvents(event.merged_event(), dirty);
      } else if (event.instance_event()) {
        return getInstanceEvents(event.instance_event(), dirty);
      } else if (event.sequence_event()) {
        return getSequenceEvents(event.sequence_event(), dirty);
      } else {
        return {} as DerivedEventLegacy;
      }
    });
  } catch (error) {
    console.error('Error fetching derived events', error);
    return [];
  }
};
